import React from "react";
import { Link } from "react-static";
import RandomImages from "../components/randomimage.js";

export default () => (
  <div>
    <RandomImages>
      <h1 className="about">
        <span>
          soju.studio is a Vienna-based team of young, multidisciplinary
          creatives with a focus on graphic design, photography and visual
          design in both, traditional and digital media.{" "}
        </span>
        <br />
        <span>
          Feel free to <Link to="/contact">contact us</Link> for freelance work
          or collaborations.
        </span>
        <br />
      </h1>
    </RandomImages>
  </div>
);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/About.js